import api from './api';

/**
 * İmzayı backend üretir; dosya tarayıcıdan doğrudan Cloudinary'ye gider (Railway bant genişliği düşük).
 * @param {File|Blob} file
 * @param {'logo'|'menu_product'|'menu_category'|'campaign'} context
 * @returns {Promise<string>} secure_url
 */
export async function uploadImageToCloudinary(file, context) {
  const sigRes = await api.get('/api/business/cloudinary/signature', {
    params: { context }
  });

  if (!sigRes.data?.success || !sigRes.data?.data) {
    throw new Error(sigRes.data?.message || 'Cloudinary imzası alınamadı');
  }

  const { cloudName, apiKey, signature, timestamp, folder } = sigRes.data.data;

  const body = new FormData();
  body.append('file', file);
  body.append('api_key', apiKey);
  body.append('timestamp', String(timestamp));
  body.append('signature', signature);
  body.append('folder', folder);
  body.append('access_mode', 'public');

  const uploadRes = await fetch(
    `https://api.cloudinary.com/v1_1/${cloudName}/image/upload`,
    { method: 'POST', body }
  );

  const json = await uploadRes.json();
  if (!uploadRes.ok || json.error) {
    throw new Error(json.error?.message || json.message || 'Cloudinary yükleme hatası');
  }
  if (!json.secure_url) {
    throw new Error('Cloudinary yanıtında secure_url yok');
  }
  /** Tarayıcıda <img> ile doğrulama yapma: yavaş ağ / CSP / özel teslimatta yanlışlıkla başarılı yüklemeyi iptal edip multer fallback’e düşerürdü. */
  return String(json.secure_url).trim();
}
